import PaymentStatus from './PaymentStatus'

export * from './PaymentStatus'

export default PaymentStatus
